import type { FetchListParams } from 'Services/ControlDataManagement/types'

export interface SchoolCalendar {
  id: string
  created_timestamp: Date
  modified_timestamp: Date
  calendar_id: string
  codespace_id: string
  year: string
  days: string
  name: string
}

export interface SchoolCalendarListResponse {
  total_results: number
  next_page: string | null
  resources: SchoolCalendar[]
}

export interface FetchSchoolCalendarListParams extends FetchListParams {
  codespace_id?: string
}

export enum SchoolCalendarTabType {
  DETAILS = 'details'
}
